module.exports = __webpack_public_path__ + "media/images/emblems/Yens-coat_of_arms-7f18746fdd6cda71aed13e98ab00cb2a.svg";